import * as types from '../actions/types';
import { tumourTypes } from '../../constants';

const initialState = {
  specimenId: '',
  status: 'N/A',
  originalImage: '',
  CADESSImage: '',
  mpp: '',
  CADESSAnalysis: {
    tumourType: '',
    gleasonPrimary: '',
    gleasonRemaining: '',
    ISUPGradeGroup: '',
    nbPosCores: '',
    carcinomaLength: '',
    carcinomaExtent: '',
  },
};


export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CADESS_DATA:
      return {
        ...state,
        specimenId: action.payload.specimen_id,
        status: action.payload.status,
        originalImage: action.payload.original_image,
        CADESSImage: action.payload.CADESS_image,
        mpp: action.payload.mpp,
        CADESSAnalysis: {
          tumourType: action.payload.CADESS_analysis.tumour_type
            ? tumourTypes.ADENOCARCINOMA : tumourTypes.NO_PRIMARY_TUMOUR,
          gleasonPrimary: action.payload.CADESS_analysis.gleason_primary.toString(),
          gleasonRemaining: action.payload.CADESS_analysis.gleason_remaining.toString(),
          ISUPGradeGroup: action.payload.CADESS_analysis.ISUP_grade_group.toString(),
          nbPosCores: action.payload.CADESS_analysis.nb_pos_cores.toString(),
          carcinomaLength: action.payload.CADESS_analysis.carcinoma_length.toString(),
          carcinomaExtent: (Math.round(action.payload.CADESS_analysis.carcinoma_extent * 100)).toString(),
          percent_4_5: (Math.round(action.payload.CADESS_analysis.percent_4_5 * 100)).toString(),
        },
      };

    case types.CLEAR_CADESS_DATA:
      return initialState;
    default:
      return state;
  }
};
